module.exports = __webpack_public_path__ + "static/media/nodejs.38c3a911.png";